import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { PreviewAspectRatio } from "../models";
import { calculateDimensions } from "../utils/calculateDimensions";

export const Container = styled.div<{ aspectRatio: PreviewAspectRatio }>`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;

    width: ${({ aspectRatio = PreviewAspectRatio.nineSixteen }) => `${calculateDimensions(aspectRatio).width}px`};
    height: ${({ aspectRatio = PreviewAspectRatio.nineSixteen }) => `${calculateDimensions(aspectRatio).height}px`};

    background: ${Colors.Gray.V50};
    border: 1px dashed ${Colors.Gray.V250};
    border-radius: 6px;
`;

export const Logo = styled.img<{ aspectRatio: PreviewAspectRatio }>`
    width: 45px;
    margin-top: ${({ aspectRatio }) => (aspectRatio === PreviewAspectRatio.nineSixteen ? "58px" : "38px")};
    padding-bottom: 12px;
`;

export const HeaderSection = styled.div`
    width: 100px;
    padding-bottom: 6px;

    font-size: 11px;
    font-weight: 500;
    line-height: 12px;
    color: ${Colors.Black.V150};
    text-align: center;
`;

export const TextSection = styled.div`
    width: 100px;

    font-size: 10px;
    font-weight: 400;
    line-height: 11.5px;
    color: ${Colors.Black.V50};
    text-align: center;
`;
